export const LTS_PAGES = [

  'analyzing',
  'analyzing-2',
  'analyzing-3',
  'analyzing-4',
  'best-app',
  'email-2',
  'lts-photo-example',
  'face-scan',
  'face-scan-animation',
  'face-scan-id',
  'lts-result',
  'analyzing-answers',
  'web-upsale-1',
  'web-upsale-3',
  'web-upsale-4',
  'web-upsale-5',
  'personal-plan',
  'personal-plan-2',
  'personal-plan-3',
  'personal-plan-4',
  'personal-plan-metabolism',
  'personal-plan-dynamic',
  'paywall',
  'change-payment-method',
  'upsale-nutrition-bundle',
  'upsale-dynamic',
  'full-body-photo',
];